<div class="horizontal-select-button" (click)="handleOnClick()">
  <button class="select-button" [class.active]="isActive">
    @if (iconSrc) {
      <div class="icon-section">
        <img [src]="iconSrc" />
      </div>
    }
    <div class="tetx-section">
      @if (title) {
        <span class="select-button-title">{{ title | translate }}</span>
      }
      @if (description) {
        <span class="select-button-description">{{ description | translate }}</span>
      }
    </div>
  </button>
</div>
